export default ((): FinderState => ({
  name: '',
  nameTyped: '',
  error: null,
  loading: false,
}))();
